/**
 * True in development builds. Gates dev-only debugging UI, e.g. the raw
 * tool-call arguments/output panels in chat.
 */
export const isDev = process.env.NODE_ENV === "development";
